import './App.css';
import BarCamPage from './components/BarCamPage';

const App = () => <BarCamPage />;

export default App;
